<!--配饰管理-->
<template>
  <div class="trialScGlIndexClass">
    <div>
      <nav-com activeIndex="7"></nav-com>
    </div>

    <div style="padding: 15px">
      <!-- Tab标签页 -->
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <!-- 产品类型维护Tab -->
        <el-tab-pane label="产品类型维护" name="productType">
          <!-- 搜索条件 -->
          <div style="text-align: left">
            <div class="searchMainClass">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form>
                    <el-form-item label="类型名称： ">
                      <el-input
                        placeholder="请输入类型名称..."
                        v-model="productTypeSearch.TYPE_NAME"
                        style="width:150px;"
                      ></el-input>
                      <label style="margin-left:6px;">类型编码：</label>
                      <el-input
                        placeholder="请输入类型编码..."
                        v-model="productTypeSearch.TYPE_CODE"
                        style="width:150px;"
                      ></el-input>
                      <label style="margin-left:6px;">状态：</label>
                      <el-select placeholder="请选择" v-model="productTypeSearch.STATUS" style="width:120px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>
                      </el-select>
                      <el-button
                        type="success"
                        style="margin-left: 15px;margin-right: 15px"
                        @click="loadProductTypeTableList"
                      >
                        综合查询
                      </el-button>
                      <el-button
                        type="primary"
                        @click="addProductTypeHandler"
                      >
                        新增产品类型
                      </el-button>
                      <div style="display:inline-block;margin-left:10px;">
                        <upload-curr-com
                          :mainLoadData="loadProductTypeTableList"
                          :op="productTypeOp"
                          :paramData="productTypeSearch"
                          :tableColumns="productTypeTableColumns"
                          mbBtnTxt="导出产品类型"
                          isUpLoadBtn="0"
                          isDownBtn="1"
                        ></upload-curr-com>
                      </div>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 产品类型列表 -->
          <div style="position: relative;">
            <el-table
              height="65vh"
              :data="productTypeTableData"
              border
              style="width: 100%"
            >
              <el-table-column label="操作" width="150" fixed="left">
                <template slot-scope="scope">
                  <el-button
                    @click="editProductTypeHandler(scope.row)"
                    type="text"
                    size="small"
                  >
                    编辑
                  </el-button>
                  <el-button
                    @click="deleteProductTypeHandler(scope.row)"
                    type="text"
                    size="small"
                    style="color:red"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="类型编码" prop="TYPE_CODE" width="150"></el-table-column>
              <el-table-column label="类型名称" prop="TYPE_NAME" width="150"></el-table-column>
              <el-table-column label="类型描述" prop="TYPE_DESC" show-overflow-tooltip></el-table-column>
              <el-table-column label="状态" prop="STATUS" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.STATUS==='1'" style="color:green">启用</span>
                  <span v-if="scope.row.STATUS==='0'" style="color:red">禁用</span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" prop="CREATE_TIME" width="160"></el-table-column>
            </el-table>
            <div style="float: right;margin-top: 20px;">
              <el-pagination
                @size-change="handleProductTypeSizeChange"
                @current-change="handleProductTypeCurrentChange"
                :current-page="productTypePageSet.currentPage"
                :page-sizes="productTypePageSet.pageSizeS"
                :page-size="productTypePageSet.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="productTypePageSet.totalNums"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>

        <!-- 产品管理Tab -->
        <el-tab-pane label="产品管理" name="product">
      <div style="text-align: left">
        <div class="searchMainClass">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form>
                    <el-form-item label="产品名称： ">
                  <el-input
                        placeholder="请输入产品名称..."
                        v-model="search.PRODUCT_NAME"
                  ></el-input>
                      <label style="margin-left:6px;">产品类型：</label>
                      <el-select placeholder="请选择" v-model="search.PRODUCT_TYPE">
                    <el-option label="全部" value=""></el-option>
                        <el-option 
                          v-for="item in productTypeList" 
                          :key="item.TYPE_CODE" 
                          :label="item.TYPE_NAME" 
                          :value="item.TYPE_CODE"
                        >
                        </el-option>
                      </el-select>
                      <label style="margin-left:6px;">产品档次：</label>
                      <el-select placeholder="请选择" v-model="search.PRODUCT_CATEGORY">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="基础" value="BASIC"></el-option>
                        <el-option label="高端" value="PREMIUM"></el-option>
                        <el-option label="奢华" value="LUXURY"></el-option>
                  </el-select>
                  <label style="margin-left:6px;">状态：</label>
                      <el-select placeholder="请选择" v-model="search.PRODUCT_STATUS">
                    <el-option label="全部" value=""></el-option>
                        <el-option label="在售" value="1"></el-option>
                        <el-option label="下架" value="0"></el-option>
                  </el-select>
                  <el-button
                    type="success"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="mainLoad"
                  >
                    综合查询
                  </el-button>
                  <el-button
                    type="warning"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="addHandler"
                  >
                        添加产品
                  </el-button>
                  <div style="display:inline-block;">
                    <upload-curr-com
                      :mainLoadData="mainLoad"
                      :op="op"
                      :paramData="search"
                      :tableColumns="tableColumns"
                      mbBtnTxt="导出产品数据"
                      isUpLoadBtn="0"
                      isDownBtn="1"
                    ></upload-curr-com>
                  </div>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>

          <!-- 产品列表 -->
      <div style="position: relative;">
        <el-table
              height="65vh"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                @click="editHandler(scope.row)"
                type="text"
                size="small"
              >
                编辑
              </el-button>
              <el-button
                @click="deleteHandler(scope.row)"
                type="text"
                size="small"
                style="color:red"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
          <template v-for="(col, index) in tableColumns">
            <el-table-column
              :prop="col.colName"
              :label="col.colText"
              :key="index"
              v-if="col.colShow"
            >
              <template slot-scope="scope">
                    <div v-if="col.colName==='PRODUCT_TYPE'">
                      {{getProductTypeName(scope.row.PRODUCT_TYPE)}}
                </div>
                    <div v-else-if="col.colName==='PRODUCT_CATEGORY'">
                      <span v-if="scope.row.PRODUCT_CATEGORY==='BASIC'" style="color:#909399">基础</span>
                      <span v-if="scope.row.PRODUCT_CATEGORY==='PREMIUM'" style="color:#409EFF">高端</span>
                      <span v-if="scope.row.PRODUCT_CATEGORY==='LUXURY'" style="color:#F56C6C">奢华</span>
                    </div>
                    <div v-else-if="col.colName==='PRODUCT_STATUS'">
                      <span v-if="scope.row.PRODUCT_STATUS==='1'" style="color:green">在售</span>
                      <span v-if="scope.row.PRODUCT_STATUS==='0'" style="color:red">下架</span>
                </div>
                <div v-else-if="col.colName==='UNIT_PRICE'">
                  ¥{{scope.row[col.colName]}}
                </div>
                <div v-else>
                  {{scope.row[col.colName]}}
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div style="float: right;margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSet.currentPage"
            :page-sizes="pageSet.pageSizeS"
            :page-size="pageSet.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageSet.totalNums"
          >
          </el-pagination>
        </div>
      </div>
        </el-tab-pane>

        <!-- 入库管理Tab -->
        <el-tab-pane label="入库管理" name="inbound">
          <div style="text-align: left;margin-bottom:15px;">
            <el-button
              type="primary"
              @click="addInboundHandler"
            >
              新增入库
            </el-button>
            <label style="margin-left:15px;">状态：</label>
            <el-select 
              v-model="inboundSearch.STATUS" 
              placeholder="请选择" 
              style="width:120px;"
              @change="loadInboundList"
            >
              <el-option label="有效" value="0"></el-option>
              <el-option label="作废" value="1"></el-option>
            </el-select>
            <label style="margin-left:15px;">操作日期：</label>
            <el-date-picker
              v-model="inboundSearch.START_DATE"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              style="width:150px;"
            >
            </el-date-picker>
            <span style="margin:0 5px;">至</span>
            <el-date-picker
              v-model="inboundSearch.END_DATE"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width:150px;"
            >
            </el-date-picker>
            <el-button
              type="success"
              style="margin-left: 15px"
              @click="loadInboundList"
            >
              查询
            </el-button>
            <div style="display:inline-block;margin-left:10px;">
              <upload-curr-com
                :mainLoadData="loadInboundList"
                :op="inboundOp"
                :paramData="inboundSearch"
                :tableColumns="inboundTableColumns"
                mbBtnTxt="导出入库数据"
                isUpLoadBtn="0"
                isDownBtn="1"
              ></upload-curr-com>
            </div>
          </div>

          <!-- 入库列表 -->
          <div style="position: relative;">
            <el-table
              height="65vh"
              :data="inboundTableData"
              border
              style="width: 100%"
            >
              <el-table-column label="操作" width="150" fixed="left">
                <template slot-scope="scope">
                  <el-button
                    @click="editInboundHandler(scope.row)"
                    type="text"
                    size="small"
                    v-if="scope.row.IS_DELETE === '0'"
                  >
                    编辑
                  </el-button>
                  <el-button
                    @click="cancelInbound(scope.row)"
                    type="text"
                    size="small"
                    style="color:red"
                    v-if="scope.row.IS_DELETE === '0'"
                  >
                    作废
                  </el-button>
                  <span v-if="scope.row.IS_DELETE === '1'" style="color:#999">已作废</span>
                </template>
              </el-table-column>
              <el-table-column label="入库单号" prop="OPERATION_NO" width="160"></el-table-column>
              <el-table-column label="产品编码" prop="PRODUCT_CODE" width="120"></el-table-column>
              <el-table-column label="产品名称" prop="PRODUCT_NAME"></el-table-column>
              <el-table-column label="产品类型" prop="PRODUCT_TYPE" width="100">
                <template slot-scope="scope">
                  {{getProductTypeName(scope.row.PRODUCT_TYPE)}}
                </template>
              </el-table-column>
              <el-table-column label="入库数量" prop="QUANTITY" width="100"></el-table-column>
              <el-table-column label="采购价格" prop="PURCHASE_PRICE" width="100">
                <template slot-scope="scope">
                  ¥{{scope.row.PURCHASE_PRICE}}
                </template>
              </el-table-column>
              <el-table-column label="采购渠道" prop="PURCHASE_CHANNEL" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.PURCHASE_CHANNEL==='ONLINE'" style="color:#409EFF">线上</span>
                  <span v-if="scope.row.PURCHASE_CHANNEL==='OFFLINE'" style="color:#67C23A">线下</span>
                </template>
              </el-table-column>
              <el-table-column label="操作日期" prop="OPERATION_DATE" width="120"></el-table-column>
              <el-table-column label="操作员" prop="OPERATOR_NAME" width="100"></el-table-column>
              <el-table-column label="仓库名称" prop="WAREHOUSE_NAME"></el-table-column>
              <el-table-column label="备注" prop="REMARKS" show-overflow-tooltip></el-table-column>
              <el-table-column label="创建时间" prop="CREATE_TIME" width="160"></el-table-column>
              <el-table-column label="图片" width="100">
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.URL && scope.row.URL.trim() !== ''"
                    style="width: 60px; height: 60px"
                    :src="scope.row.URL"
                    :preview-src-list="[scope.row.URL]"
                    fit="cover"
                  >
                  </el-image>
                  <span v-else style="color:#999;">暂无图片</span>
                </template>
              </el-table-column>
            </el-table>
            <div style="float: right;margin-top: 20px;">
              <el-pagination
                @size-change="handleInboundSizeChange"
                @current-change="handleInboundCurrentChange"
                :current-page="inboundPageSet.currentPage"
                :page-sizes="inboundPageSet.pageSizeS"
                :page-size="inboundPageSet.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="inboundPageSet.totalNums"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>

        <!-- 出库管理Tab -->
        <el-tab-pane label="出库管理" name="outbound">
          <div style="text-align: left;margin-bottom:15px;">
            <el-button
              type="danger"
              @click="addOutboundHandler"
            >
              新增出库
            </el-button>
            <label style="margin-left:15px;">操作日期：</label>
            <el-date-picker
              v-model="outboundSearch.START_DATE"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              style="width:150px;"
            >
            </el-date-picker>
            <span style="margin:0 5px;">至</span>
            <el-date-picker
              v-model="outboundSearch.END_DATE"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width:150px;"
            >
            </el-date-picker>
            <el-button
              type="success"
              style="margin-left: 15px"
              @click="loadOutboundList"
            >
              查询
            </el-button>
            <div style="display:inline-block;margin-left:10px;">
              <upload-curr-com
                :mainLoadData="loadOutboundList"
                :op="outboundOp"
                :paramData="outboundSearch"
                :tableColumns="outboundTableColumns"
                mbBtnTxt="导出出库数据"
                isUpLoadBtn="0"
                isDownBtn="1"
              ></upload-curr-com>
            </div>
          </div>

          <!-- 出库列表 -->
          <div style="position: relative;">
            <el-table
              height="65vh"
              :data="outboundTableData"
              border
              style="width: 100%"
            >
              <el-table-column label="操作" width="200" fixed="left">
                <template slot-scope="scope">
                  <el-button
                    @click="changeOutboundStatus(scope.row, 'RECOVER')"
                    type="text"
                    size="small"
                    v-if="scope.row.IS_DELETE === '0' && scope.row.OUTBOUND_STATUS !== 'RECOVER' && scope.row.OUTBOUND_STATUS !== 'SOLD'"
                  >
                    回收
                  </el-button>
                  <el-button
                    @click="openSellDialog(scope.row)"
                    type="text"
                    size="small"
                    style="color:orange"
                    v-if="scope.row.IS_DELETE === '0' && scope.row.OUTBOUND_STATUS !== 'SOLD'"
                  >
                    售卖
                  </el-button>
                  <el-button
                    @click="cancelOutbound(scope.row)"
                    type="text"
                    size="small"
                    style="color:red"
                    v-if="scope.row.IS_DELETE === '0'"
                  >
                    作废
                  </el-button>
                  <span v-if="scope.row.IS_DELETE === '1'" style="color:#999">已作废</span>
                  <span v-if="scope.row.IS_DELETE === '0' && scope.row.OUTBOUND_STATUS === 'SOLD'" style="color:green">已售卖</span>
                  <span v-if="scope.row.IS_DELETE === '0' && scope.row.OUTBOUND_STATUS === 'RECOVER'" style="color:blue">已回收</span>
                </template>
              </el-table-column>
              <el-table-column label="操作单号" prop="OPERATION_NO" width="180"></el-table-column>
              <el-table-column label="产品编码" prop="PRODUCT_CODE" width="120"></el-table-column>
              <el-table-column label="产品名称" prop="PRODUCT_NAME"></el-table-column>
              <el-table-column label="产品类型" prop="PRODUCT_TYPE" width="100">
                <template slot-scope="scope">
                  {{getProductTypeName(scope.row.PRODUCT_TYPE)}}
                </template>
              </el-table-column>
              <el-table-column label="出库数量" prop="QUANTITY" width="100"></el-table-column>
              <el-table-column label="房源" prop="HOUSE_NAME" width="150"></el-table-column>
              <el-table-column label="领用人" prop="RECIPIENT_NAME" width="100"></el-table-column>
              <el-table-column label="领用日期" prop="RECIPIENT_DATE" width="120"></el-table-column>
              <el-table-column label="操作日期" prop="OPERATION_DATE" width="120"></el-table-column>
              <el-table-column label="操作员" prop="OPERATOR_NAME" width="100"></el-table-column>
              <el-table-column label="入库价格" prop="PURCHASE_PRICE" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.PURCHASE_PRICE">¥{{scope.row.PURCHASE_PRICE}}</span>
                  <span v-else style="color:#999;">-</span>
                </template>
              </el-table-column>
              <el-table-column label="出库价格" prop="CK_PRICE" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.CK_PRICE">¥{{scope.row.CK_PRICE}}</span>
                  <span v-else style="color:#999;">-</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="REMARKS" show-overflow-tooltip></el-table-column>
              <el-table-column label="创建时间" prop="CREATE_TIME" width="160"></el-table-column>
              <el-table-column label="图片" width="100">
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.URL && scope.row.URL.trim() !== ''"
                    style="width: 60px; height: 60px"
                    :src="scope.row.URL"
                    :preview-src-list="[scope.row.URL]"
                    fit="cover"
                  >
                  </el-image>
                  <span v-else style="color:#999;">暂无图片</span>
                </template>
              </el-table-column>
            </el-table>
            <div style="float: right;margin-top: 20px;">
              <el-pagination
                @size-change="handleOutboundSizeChange"
                @current-change="handleOutboundCurrentChange"
                :current-page="outboundPageSet.currentPage"
                :page-sizes="outboundPageSet.pageSizeS"
                :page-size="outboundPageSet.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="outboundPageSet.totalNums"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- 添加/编辑产品 开始 -->
      <el-dialog
        :title="czData.flag==='ADD'?'添加产品':'编辑产品'"
        :visible.sync="dialogVisible"
        width="75%"
      >
        <span>
          <div class="addClassModel">
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;产品名称<span style="color:red;">*</span>：</label>
                  <el-input
                    v-model="czData.row.PRODUCT_NAME"
                    style="width:70%;"
                    placeholder="请输入产品名称..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;产品类型<span style="color:red;">*</span>：</label>
                  <el-select placeholder="请选择" v-model="czData.row.PRODUCT_TYPE" style="width:70%;">
                    <el-option 
                      v-for="item in productTypeList" 
                      :key="item.TYPE_CODE" 
                      :label="item.TYPE_NAME" 
                      :value="item.TYPE_CODE"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;产品编码：</label>
                  <el-input
                    v-model="czData.row.PRODUCT_CODE"
                    style="width:70%;"
                    placeholder="自动生成"
                    disabled
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;产品档次：</label>
                  <el-select placeholder="请选择" v-model="czData.row.PRODUCT_CATEGORY" style="width:70%;">
                    <el-option label="基础" value="BASIC"></el-option>
                    <el-option label="高端" value="PREMIUM"></el-option>
                    <el-option label="奢华" value="LUXURY"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;库存数量：</label>
                  <el-input
                    v-model="czData.row.STOCK_QUANTITY"
                    style="width:70%;"
                    placeholder="库存数量"
                    type="number"
                    disabled
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;产品状态<span style="color:red;">*</span>：</label>
                  <el-select placeholder="请选择" v-model="czData.row.PRODUCT_STATUS" style="width:70%;">
                    <el-option label="在售" value="1"></el-option>
                    <el-option label="下架" value="0"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;供应商名称：</label>
                  <el-input
                    v-model="czData.row.SUPPLIER_NAME"
                    style="width:85%;"
                    placeholder="请输入供应商名称..."
                  ></el-input>
                </el-col>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;供应商联系方式：</label>
                  <el-input
                    v-model="czData.row.SUPPLIER_CONTACT"
                    style="width:85%;"
                    placeholder="请输入供应商联系方式..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;产品描述：</label>
                  <el-input
                    type="textarea"
                    :rows="4"
                    v-model="czData.row.PRODUCT_DESC"
                    style="width:95%;"
                    placeholder="请输入产品描述..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">
            取 消
          </el-button>
          <el-button type="primary" @click="addOrEditHandler">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <!-- 添加/编辑产品 结束 -->

      <!-- 新增/编辑入库 开始 -->
      <el-dialog
        :title="inboundDialogTitle"
        :visible.sync="inboundDialogVisible"
        width="80%"
      >
        <span>
          <div class="addClassModel">
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;选择产品<span style="color:red;">*</span>：</label>
                  <el-select 
                    placeholder="请选择产品" 
                    v-model="inboundData.PRODUCT_ID" 
                    style="width:70%;"
                    @change="handleInboundProductChange"
                    filterable
                    remote
                    :remote-method="searchProducts"
                    :loading="productSearchLoading"
                  >
                    <el-option 
                      v-for="item in productListForInbound" 
                      :key="item.PRODUCT_ID" 
                      :label="item.PRODUCT_CODE + ' - ' + item.PRODUCT_NAME + ' (库存:' + item.STOCK_QUANTITY + ')'" 
                      :value="item.PRODUCT_ID"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;产品类型：</label>
                  <el-input
                    v-model="inboundData.PRODUCT_TYPE_TEXT"
                    style="width:70%;"
                    disabled
                    placeholder="选择产品后自动显示"
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;当前库存：</label>
                  <el-input
                    v-model="inboundData.CURRENT_STOCK"
                    style="width:70%;"
                    disabled
                    placeholder="选择产品后显示"
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;入库数量<span style="color:red;">*</span>：</label>
                  <el-input
                    v-model="inboundData.QUANTITY"
                    style="width:70%;"
                    placeholder="请输入入库数量..."
                    type="number"
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;采购价格：</label>
                  <el-input
                    v-model="inboundData.PURCHASE_PRICE"
                    style="width:70%;"
                    placeholder="请输入采购价格..."
                    type="number"
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;采购渠道：</label>
                  <el-select placeholder="请选择" v-model="inboundData.PURCHASE_CHANNEL" style="width:70%;">
                    <el-option label="线上" value="ONLINE"></el-option>
                    <el-option label="线下" value="OFFLINE"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;操作日期<span style="color:red;">*</span>：</label>
                  <el-date-picker
                    v-model="inboundData.OPERATION_DATE"
                    type="date"
                    placeholder="选择日期"
                    style="width:70%;"
                    value-format="yyyyMMdd"
                  >
                  </el-date-picker>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;仓库名称：</label>
                  <el-input
                    v-model="inboundData.WAREHOUSE_NAME"
                    style="width:70%;"
                    placeholder="请输入仓库名称..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;备注：</label>
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="inboundData.REMARKS"
                    style="width:95%;"
                    placeholder="请输入备注..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;上传图片：</label>
                  <div style="display:inline-block; width:95%; vertical-align:top;">
                    <el-upload
                      class="upload-demo"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-success="handleInboundImageSuccess"
                      :before-upload="beforeInboundImageUpload"
                      :on-remove="handleInboundImageRemove"
                      :file-list="inboundData.imageFileList"
                      :limit="1"
                      accept="image/*"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip" style="margin-top: 10px; font-size: 12px; color: #909399;">
                      只能上传 JPG/PNG 图片，且不超过 500KB
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="inboundDialogVisible = false">
            取 消
          </el-button>
          <el-button type="primary" @click="submitInbound">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <!-- 新增入库 结束 -->

      <!-- 新增出库 开始 -->
      <el-dialog
        title="新增出库"
        :visible.sync="outboundDialogVisible"
        width="80%"
      >
        <span>
          <div class="addClassModel">
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;选择产品<span style="color:red;">*</span>：</label>
                  <el-select 
                    placeholder="请选择产品" 
                    v-model="outboundData.PRODUCT_ID" 
                    style="width:70%;"
                    @change="handleOutboundProductChange"
                    filterable
                    remote
                    :remote-method="searchProductsForOutbound"
                    :loading="outboundProductSearchLoading"
                  >
                    <el-option 
                      v-for="item in productListForOutbound" 
                      :key="item.PRODUCT_ID" 
                      :label="item.PRODUCT_CODE + ' - ' + item.PRODUCT_NAME + ' (库存:' + item.STOCK_QUANTITY + ')'" 
                      :value="item.PRODUCT_ID"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;产品类型：</label>
                  <el-input
                    v-model="outboundData.PRODUCT_TYPE_TEXT"
                    style="width:70%;"
                    disabled
                    placeholder="选择产品后自动显示"
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;当前库存：</label>
                  <el-input
                    v-model="outboundData.CURRENT_STOCK"
                    style="width:70%;"
                    disabled
                    placeholder="选择产品后显示"
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;入库价格：</label>
                  <el-input
                    v-model="outboundData.PURCHASE_PRICE_DISPLAY"
                    style="width:70%;"
                    disabled
                    placeholder="选择产品后显示"
                  >
                    <template slot="prepend">¥</template>
                  </el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label>&nbsp;&nbsp;出库数量<span style="color:red;">*</span>：</label>
                  <el-input
                    v-model="outboundData.QUANTITY"
                    style="width:70%;"
                    placeholder="请输入出库数量..."
                    type="number"
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;操作日期<span style="color:red;">*</span>：</label>
                  <el-date-picker
                    v-model="outboundData.OPERATION_DATE"
                    type="date"
                    placeholder="选择日期"
                    style="width:70%;"
                    value-format="yyyyMMdd"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;选择房源<span style="color:red;">*</span>：</label>
                  <el-select 
                    placeholder="请选择房源" 
                    v-model="outboundData.HOUSEID" 
                    style="width:70%;"
                    @change="handleHouseChange"
                    filterable
                    remote
                    :remote-method="searchHouses"
                    :loading="houseSearchLoading"
                  >
                    <el-option 
                      v-for="item in houseList" 
                      :key="item.HOUSEID" 
                      :label="item.HOUSE_NAME + ' - ' + item.ADDRESS" 
                      :value="item.HOUSEID"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;房源地址：</label>
                  <el-input
                    v-model="outboundData.HOUSE_ADDRESS"
                    style="width:70%;"
                    disabled
                    placeholder="选择房源后显示"
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;领用人：</label>
                  <el-input
                    v-model="outboundData.RECIPIENT_NAME"
                    style="width:70%;"
                    placeholder="请输入领用人..."
                  ></el-input>
                </el-col>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;领用日期：</label>
                  <el-date-picker
                    v-model="outboundData.RECIPIENT_DATE"
                    type="date"
                    placeholder="选择日期"
                    style="width:70%;"
                    value-format="yyyyMMdd"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </div>

            <!-- 出库价格已隐藏
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;出库价格：</label>
                  <el-input
                    v-model="outboundData.CK_PRICE"
                    style="width:70%;"
                    placeholder="请输入出库价格..."
                    type="number"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
            -->

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;备注：</label>
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="outboundData.REMARKS"
                    style="width:95%;"
                    placeholder="请输入备注..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <!-- 新增出库时已隐藏图片上传，售卖时才上传图片
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;上传图片：</label>
                  <div style="display:inline-block; width:95%; vertical-align:top;">
                    <el-upload
                      class="upload-demo"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-success="handleOutboundImageSuccess"
                      :before-upload="beforeOutboundImageUpload"
                      :on-remove="handleOutboundImageRemove"
                      :file-list="outboundData.imageFileList"
                      :limit="1"
                      accept="image/*"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip" style="margin-top: 10px; font-size: 12px; color: #909399;">
                      只能上传 JPG/PNG 图片，且不超过 500KB
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            -->
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="outboundDialogVisible = false">
            取 消
          </el-button>
          <el-button type="primary" @click="submitOutbound">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <!-- 新增出库 结束 -->

      <!-- 售卖对话框 开始 -->
      <el-dialog
        title="售卖确认"
        :visible.sync="sellDialogVisible"
        width="60%"
      >
        <span>
          <div class="addClassModel">
            <div style="margin-bottom:20px;">
              <el-alert
                title="提示：售卖后将不可回收，请谨慎操作！"
                type="warning"
                :closable="false"
                show-icon>
              </el-alert>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;产品名称：</label>
                  <el-input
                    v-model="sellData.PRODUCT_NAME"
                    style="width:70%;"
                    disabled
                  ></el-input>
                </el-col>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;出库数量：</label>
                  <el-input
                    v-model="sellData.QUANTITY"
                    style="width:70%;"
                    disabled
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;入库价格：</label>
                  <el-input
                    v-model="sellData.PURCHASE_PRICE_DISPLAY"
                    style="width:70%;"
                    disabled
                    placeholder="暂无入库价格"
                  >
                    <template slot="prepend">¥</template>
                  </el-input>
                </el-col>
                <el-col :span="12" style="text-align: left;">
                  <label>&nbsp;&nbsp;出库价格<span style="color:red;">*</span>：</label>
                  <el-input
                    v-model="sellData.CK_PRICE"
                    style="width:70%;"
                    placeholder="请输入出库价格..."
                    type="number"
                  >
                    <template slot="prepend">¥</template>
                  </el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;上传图片：</label>
                  <div style="display:inline-block; width:95%; vertical-align:top;">
                    <el-upload
                      class="upload-demo"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-success="handleSellImageSuccess"
                      :before-upload="beforeSellImageUpload"
                      :on-remove="handleSellImageRemove"
                      :file-list="sellData.imageFileList"
                      :limit="1"
                      accept="image/*"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip" style="margin-top: 10px; font-size: 12px; color: #909399;">
                      只能上传 JPG/PNG 图片，且不超过 500KB
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="sellDialogVisible = false">
            取 消
          </el-button>
          <el-button type="primary" @click="submitSell">
            确认售卖
          </el-button>
        </span>
      </el-dialog>
      <!-- 售卖对话框 结束 -->

      <!-- 添加/编辑产品类型 开始 -->
      <el-dialog
        :title="productTypeFlag==='ADD'?'添加产品类型':'编辑产品类型'"
        :visible.sync="productTypeDialogVisible"
        width="50%"
      >
        <span>
          <div class="addClassModel">
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;类型名称<span style="color:red;">*</span>：</label>
                  <el-input
                    v-model="productTypeData.TYPE_NAME"
                    style="width:80%;"
                    placeholder="请输入类型名称（如：果盘）..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;类型编码：</label>
                  <el-input
                    v-model="productTypeData.TYPE_CODE"
                    style="width:80%;"
                    placeholder="系统自动生成..."
                    disabled
                  ></el-input>
                  <span style="color:#999;font-size:12px;margin-left:10px;">
                    (提交时自动生成唯一编码)
                  </span>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;状态<span style="color:red;">*</span>：</label>
                  <el-select placeholder="请选择" v-model="productTypeData.STATUS" style="width:80%;">
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="24" style="text-align: left;">
                  <label>&nbsp;&nbsp;类型描述：</label>
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="productTypeData.TYPE_DESC"
                    style="width:80%;"
                    placeholder="请输入类型描述..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="productTypeDialogVisible = false">
            取 消
          </el-button>
          <el-button type="primary" @click="submitProductType">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <!-- 添加/编辑产品类型 结束 -->
    </div>
  </div>
</template>

<script>
import NavCom from "../../components/navCom/NavMainCom.vue";
import UploadCurrCom from "../../components/uploadCurrCom/UploadCurrCom.vue";
import allParam from "../../allParam/allParam.vue";
var utilPost, op;
export default {
  name: "AccessoriesGlIndex",
  components: { NavCom, UploadCurrCom, allParam },
  data() {
    return {
      uploadImgUrl: allParam.uploadImgUrl, // 图片上传地址
      activeTab: "productType", // 当前激活的tab页
      rows: [],
      action: allParam.downMbUrl,
      objDataParam: "",
      search: {
        PRODUCT_NAME: "",
        PRODUCT_TYPE: "",
        PRODUCT_CATEGORY: "",
        PRODUCT_STATUS: ""
      },
      /**分页 开始 */
      pageSet: {
        currentPage: 1, //当前页页码
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      /**分页 结束 */
      /**入库分页 */
      inboundPageSet: {
        currentPage: 1,
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10,
        totalNums: 0
      },
      /**出库分页 */
      outboundPageSet: {
        currentPage: 1,
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10,
        totalNums: 0
      },
      tableColumns: [
        {
          colName: "PRODUCT_ID",
          colText: "产品ID",
          colShow: false
        },
        {
          colName: "PRODUCT_CODE",
          colText: "产品编码",
          colShow: true
        },
        {
          colName: "PRODUCT_NAME",
          colText: "产品名称",
          colShow: true
        },
        {
          colName: "PRODUCT_TYPE",
          colText: "产品类型",
          colShow: true
        },
        {
          colName: "PRODUCT_CATEGORY",
          colText: "产品档次",
          colShow: true
        },
        {
          colName: "UNIT_PRICE",
          colText: "单价",
          colShow: false
        },
        {
          colName: "STOCK_QUANTITY",
          colText: "库存数量",
          colShow: true
        },
        {
          colName: "MIN_STOCK",
          colText: "最小库存",
          colShow: false
        },
        {
          colName: "MAX_STOCK",
          colText: "最大库存",
          colShow: false
        },
        {
          colName: "SUPPLIER_NAME",
          colText: "供应商名称",
          colShow: true
        },
        {
          colName: "SUPPLIER_CONTACT",
          colText: "供应商联系方式",
          colShow: true
        },
        {
          colName: "PRODUCT_STATUS",
          colText: "产品状态",
          colShow: true
        },
        {
          colName: "PRODUCT_DESC",
          colText: "产品描述",
          colShow: false
        },
        {
          colName: "CREATE_USER",
          colText: "创建人",
          colShow: false
        },
        {
          colName: "CREATE_TIME",
          colText: "创建时间",
          colShow: true
        },
        {
          colName: "UPDATE_USER",
          colText: "更新人",
          colShow: false
        },
        {
          colName: "UPDATE_TIME",
          colText: "更新时间",
          colShow: false
        },
        {
          colName: "IS_DELETE",
          colText: "是否删除",
          colShow: false
        }
      ],
      tableData: [],
      czData: {
        row: {},
        flag: "ADD"
      },
      dialogVisible: false,
      // 入库相关
      inboundDialogVisible: false,
      inboundTableData: [],
      inboundSearch: {
        START_DATE: "",
        END_DATE: "",
        STATUS: "0" // 默认只显示有效数据：0有效，1作废
      },
      inboundDialogTitle: "新增入库", // 弹窗标题：新增入库/编辑入库
      inboundEditMode: false, // 是否为编辑模式
      inboundData: {
        OPERATION_TYPE: "IN", // 操作类型：IN入库
        PRODUCT_ID: "",
        PRODUCT_NAME: "",
        PRODUCT_CODE: "",
        PRODUCT_TYPE: "",
        PRODUCT_TYPE_TEXT: "",
        CURRENT_STOCK: "",
        QUANTITY: "",
        UNIT_PRICE: "",
        PURCHASE_PRICE: "", // 采购价格
        PURCHASE_CHANNEL: "OFFLINE", // 采购渠道：ONLINE线上、OFFLINE线下
        OPERATION_DATE: "",
        WAREHOUSE_NAME: "",
        REMARKS: "",
        IMGPATH: "", // 图片原图路径
        IMGPATH_YS: "", // 图片压缩图路径
        URL: "", // 图片访问URL
        imageFileList: [] // 上传组件的文件列表
      },
      productListForInbound: [], // 入库可选产品列表
      productSearchLoading: false, // 产品搜索加载状态
      // 出库相关
      outboundDialogVisible: false,
      outboundTableData: [],
      outboundSearch: {
        START_DATE: "",
        END_DATE: ""
      },
      outboundData: {
        OPERATION_TYPE: "OUT", // 操作类型：OUT出库
        PRODUCT_ID: "",
        PRODUCT_NAME: "",
        PRODUCT_CODE: "",
        PRODUCT_TYPE: "",
        PRODUCT_TYPE_TEXT: "",
        CURRENT_STOCK: "",
        PURCHASE_PRICE_DISPLAY: "", // 入库价格（只读显示）
        QUANTITY: "",
        CK_PRICE: "", // 出库价格
        OPERATION_DATE: "",
        HOUSEID: "",
        HOUSE_NAME: "",
        HOUSE_ADDRESS: "",
        RECIPIENT_NAME: "",
        RECIPIENT_DATE: "",
        REMARKS: "",
        IMGPATH: "", // 图片原图路径
        IMGPATH_YS: "", // 图片压缩图路径
        URL: "", // 图片访问URL
        imageFileList: [] // 上传组件的文件列表
      },
      productListForOutbound: [], // 出库可选产品列表
      outboundProductSearchLoading: false, // 出库产品搜索加载状态
      // 售卖相关
      sellDialogVisible: false,
      sellData: {
        OUTBOUND_ID: "",
        PRODUCT_ID: "",
        PRODUCT_NAME: "",
        QUANTITY: "",
        PURCHASE_PRICE_DISPLAY: "", // 入库价格（只读显示）
        CK_PRICE: "", // 出库价格
        IMGPATH: "", // 图片原图路径
        IMGPATH_YS: "", // 图片压缩图路径
        URL: "", // 图片访问URL
        imageFileList: [] // 上传组件的文件列表
      },
      houseList: [], // 房源列表
      houseSearchLoading: false, // 房源搜索加载状态
      // 产品类型维护相关
      productTypeList: [], // 产品类型列表
      productTypeTableData: [], // 产品类型表格数据
      productTypeSearch: {
        TYPE_NAME: "",
        TYPE_CODE: "",
        STATUS: ""
      },
      productTypePageSet: {
        currentPage: 1,
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10,
        totalNums: 0
      },
      productTypeDialogVisible: false,
      productTypeData: {
        TYPE_CODE: "",
        TYPE_NAME: "",
        TYPE_DESC: "",
        STATUS: "1"
      },
      productTypeFlag: "ADD", // ADD/UPT
      // 产品类型维护 tableColumns
      productTypeTableColumns: [
        { colName: "TYPE_CODE", colText: "类型编码", colShow: true },
        { colName: "TYPE_NAME", colText: "类型名称", colShow: true },
        { colName: "TYPE_DESC", colText: "类型描述", colShow: true },
        { colName: "STATUS", colText: "状态", colShow: true },
        { colName: "CREATE_TIME", colText: "创建时间", colShow: true }
      ],
      // 入库管理 tableColumns
      inboundTableColumns: [
        { colName: "OPERATION_NO", colText: "操作单号", colShow: true },
        { colName: "PRODUCT_CODE", colText: "产品编码", colShow: true },
        { colName: "PRODUCT_NAME", colText: "产品名称", colShow: true },
        { colName: "PRODUCT_TYPE", colText: "产品类型", colShow: true },
        { colName: "QUANTITY", colText: "入库数量", colShow: true },
        { colName: "PURCHASE_PRICE", colText: "采购价格", colShow: true },
        { colName: "PURCHASE_CHANNEL", colText: "采购渠道", colShow: true },
        { colName: "OPERATION_DATE", colText: "操作日期", colShow: true },
        { colName: "WAREHOUSE_NAME", colText: "仓库名称", colShow: true },
        { colName: "REMARKS", colText: "备注", colShow: true },
        { colName: "URL", colText: "图片URL", colShow: true },
        { colName: "CREATE_TIME", colText: "创建时间", colShow: true },
        { colName: "IS_DELETE", colText: "状态", colShow: true }
      ],
      // 出库管理 tableColumns
      outboundTableColumns: [
        { colName: "OPERATION_NO", colText: "操作单号", colShow: true },
        { colName: "PRODUCT_CODE", colText: "产品编码", colShow: true },
        { colName: "PRODUCT_NAME", colText: "产品名称", colShow: true },
        { colName: "PRODUCT_TYPE", colText: "产品类型", colShow: true },
        { colName: "QUANTITY", colText: "出库数量", colShow: true },
        { colName: "HOUSE_NAME", colText: "房源信息", colShow: true },
        { colName: "PURCHASE_PRICE", colText: "入库价格", colShow: true },
        { colName: "CK_PRICE", colText: "出库价格", colShow: true },
        { colName: "OPERATION_DATE", colText: "操作日期", colShow: true },
        { colName: "RECIPIENT_NAME", colText: "领取人", colShow: true },
        { colName: "RECIPIENT_DATE", colText: "领取日期", colShow: true },
        { colName: "OUTBOUND_STATUS", colText: "出库状态", colShow: true },
        { colName: "REMARKS", colText: "备注", colShow: true },
        { colName: "URL", colText: "图片URL", colShow: true },
        { colName: "CREATE_TIME", colText: "创建时间", colShow: true }
      ]
    };
  },
  created() {
    this.op = "adminProductsGl";
    this.inboundOp = "adminInventoryGl"; // 入库管理接口
    this.outboundOp = "adminInventoryGl"; // 出库管理接口
    this.productTypeOp = "adminProductTypeGl"; // 产品类型管理接口
    this.utilPost = this.$util.handler;
  },
  mounted() {
    this.loadProductTypeList(); // 加载产品类型列表（用于下拉框）
    this.loadProductTypeTableList(); // 首次进入默认加载产品类型维护数据
    this.mainLoad();
  },
  methods: {
    handleSelectionChange(val) {
      this.rows = val;
    },
    /**分页方法 开始 */
    handleSizeChange(val) {
      this.pageSet.pageSize = val;
      this.mainLoad();
    },
    handleCurrentChange(val) {
      this.pageSet.currentPage = val;
      this.mainLoad();
    },
    //加载主列表数据
    mainLoad() {
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "mainLoad" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          this.isShowContent = false;
          return;
        }
        this.pageSet.totalNums = data.totalNums;
        this.tableData = data.content;
        this.isShowContent = true;
      });
    },
    /**分页方法 结束 */
    
    //添加产品
    addHandler() {
      // 获取第一个启用的产品类型作为默认值
      const firstActiveType = this.productTypeList.find(t => t.STATUS === '1');
      this.czData.row = {
        PRODUCT_CODE: "",
        PRODUCT_NAME: "",
        PRODUCT_TYPE: firstActiveType ? firstActiveType.TYPE_CODE : "",
        PRODUCT_CATEGORY: "BASIC",
        STOCK_QUANTITY: 0,
        SUPPLIER_NAME: "",
        SUPPLIER_CONTACT: "",
        PRODUCT_STATUS: "1",
        PRODUCT_DESC: ""
      };
      this.czData.flag = "ADD";
      this.dialogVisible = true;
    },
    
    //编辑产品
    editHandler(row) {
      this.czData.row = JSON.parse(JSON.stringify(row));
      this.czData.flag = "UPT";
      this.dialogVisible = true;
    },
    
    //添加或编辑提交
    addOrEditHandler() {
      if (!this.czData.row.PRODUCT_NAME) {
        alert("请输入产品名称");
        return;
      }
      if (!this.czData.row.PRODUCT_TYPE) {
        alert("请选择产品类型");
        return;
      }
      if (!this.czData.row.PRODUCT_STATUS) {
        alert("请选择产品状态");
        return;
      }
      
      if (!confirm("是否提交？")) {
        return;
      }
      
      var busData = {
        row: this.czData.row,
        flag: this.czData.flag
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "addOrEditorOrDel"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.mainLoad();
          this.dialogVisible = false;
          return;
        }
      });
    },
    
    //删除产品
    deleteHandler(row) {
      if (!confirm("是否删除该产品？")) {
        return;
      }
      
      var busData = {
        row: row,
        flag: "DEL"
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "addOrEditorOrDel"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.mainLoad();
          return;
        }
      });
    },

    // Tab切换 - 自动调用对应的数据加载方法
    handleTabClick(tab) {
      if (tab.name === 'productType') {
        // 产品类型维护
        this.loadProductTypeTableList();
      } else if (tab.name === 'product') {
        // 产品管理
        this.mainLoad();
      } else if (tab.name === 'inbound') {
        // 入库管理
        this.loadInboundList();
      } else if (tab.name === 'outbound') {
        // 出库管理
        this.loadOutboundList();
      }
    },

    // 入库管理相关方法
    // 加载入库列表
    loadInboundList() {
      var busData = {
        pageSet: this.inboundPageSet,
        search: this.inboundSearch
      };
      var paramData = {
        headerData: {
          op: this.inboundOp,
          methodName: "mainLoad"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess) {
          this.inboundPageSet.totalNums = data.totalNums;
          this.inboundTableData = data.content;
        }
      });
    },

    // 入库分页
    handleInboundSizeChange(val) {
      this.inboundPageSet.pageSize = val;
      this.loadInboundList();
    },
    handleInboundCurrentChange(val) {
      this.inboundPageSet.currentPage = val;
      this.loadInboundList();
    },

    // 打开新增入库对话框
    addInboundHandler() {
      this.inboundDialogTitle = "新增入库";
      this.inboundEditMode = false;
      this.inboundData = {
        OPERATION_TYPE: "IN",
        PRODUCT_ID: "",
        PRODUCT_NAME: "",
        PRODUCT_CODE: "",
        PRODUCT_TYPE: "",
        PRODUCT_TYPE_TEXT: "",
        CURRENT_STOCK: "",
        QUANTITY: "",
        UNIT_PRICE: "",
        PURCHASE_PRICE: "",
        PURCHASE_CHANNEL: "OFFLINE",
        OPERATION_DATE: this.getCurrentDateYYYYMMDD(),
        WAREHOUSE_NAME: "",
        REMARKS: "",
        IMGPATH: "",
        IMGPATH_YS: "",
        URL: "",
        imageFileList: []
      };
      // 加载产品列表
      this.loadProductListForInbound();
      this.inboundDialogVisible = true;
    },

    // 编辑入库
    editInboundHandler(row) {
      this.inboundDialogTitle = "编辑入库";
      this.inboundEditMode = true;
      this.inboundData = {
        INBOUND_ID: row.INBOUND_ID,
        OPERATION_TYPE: "IN",
        PRODUCT_ID: row.PRODUCT_ID,
        PRODUCT_NAME: row.PRODUCT_NAME,
        PRODUCT_CODE: row.PRODUCT_CODE,
        PRODUCT_TYPE: row.PRODUCT_TYPE || "",
        PRODUCT_TYPE_TEXT: row.PRODUCT_TYPE_TEXT || "",
        CURRENT_STOCK: row.CURRENT_STOCK || "",
        QUANTITY: row.QUANTITY,
        UNIT_PRICE: row.UNIT_PRICE || "",
        PURCHASE_PRICE: row.PURCHASE_PRICE || "",
        PURCHASE_CHANNEL: row.PURCHASE_CHANNEL || "OFFLINE",
        OPERATION_DATE: row.OPERATION_DATE,
        WAREHOUSE_NAME: row.WAREHOUSE_NAME || "",
        REMARKS: row.REMARKS || "",
        IMGPATH: row.IMGPATH || "",
        IMGPATH_YS: row.IMGPATH_YS || "",
        URL: row.URL || "",
        imageFileList: []
      };
      // 如果有图片，构建文件列表（el-upload需要name和url属性）
      if (row.URL && row.URL.trim() !== "") {
        this.inboundData.imageFileList = [{
          name: row.IMGPATH ? row.IMGPATH.split('/').pop() : 'image.jpg',
          url: row.URL
        }];
      }
      // 加载产品列表
      this.loadProductListForInbound();
      this.inboundDialogVisible = true;
    },

    // 作废入库
    cancelInbound(row) {
      this.$confirm('作废后将重新计算库存，是否继续作废该入库单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var busData = {
          INBOUND_ID: row.INBOUND_ID,
          PRODUCT_ID: row.PRODUCT_ID
        };
        var paramData = {
          headerData: {
            op: "adminInventoryGl",
            methodName: "cancelInbound"
          },
          busData: busData
        };
        this.utilPost.paramData = paramData;
        this.utilPost.sendPost().then(data => {
          if (data.isSuccess) {
            this.$message.success(data.msg || '作废成功！');
            this.loadInboundList();
            this.loadProductList(); // 刷新产品列表以显示最新库存
          } else {
            this.$message.error(data.msg || '作废失败');
          }
        });
      }).catch(() => {
        this.$message.info('已取消作废');
      });
    },

    // 加载入库可选产品列表
    loadProductListForInbound() {
      var busData = {
        pageSet: {
          currentPage: 1,
          pageSize: 1000
        },
        search: {
          PRODUCT_NAME: "",
          PRODUCT_TYPE: "",
          PRODUCT_CATEGORY: "",
          PRODUCT_STATUS: "1" // 只加载在售产品
        }
      };
      var paramData = {
        headerData: {
          op: "adminProductsGl",
          methodName: "mainLoad"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess) {
          this.productListForInbound = data.content;
        }
      });
    },

    // 搜索产品（远程搜索）
    searchProducts(query) {
      if (query !== '') {
        this.productSearchLoading = true;
        var busData = {
          pageSet: {
            currentPage: 1,
            pageSize: 1000
          },
          search: {
            PRODUCT_NAME: query,
            PRODUCT_TYPE: "",
            PRODUCT_CATEGORY: "",
            PRODUCT_STATUS: "1" // 只加载在售产品
          }
        };
        var paramData = {
          headerData: {
            op: "adminProductsGl",
            methodName: "mainLoad"
          },
          busData: busData
        };
        this.utilPost.paramData = paramData;
        this.utilPost.sendPost().then(data => {
          this.productSearchLoading = false;
          if (data.isSuccess) {
            this.productListForInbound = data.content;
          }
        });
      } else {
        this.loadProductListForInbound();
      }
    },

    // 入库产品选择改变
    handleInboundProductChange(val) {
      const selected = this.productListForInbound.find(item => item.PRODUCT_ID === val);
      if (selected) {
        this.inboundData.PRODUCT_NAME = selected.PRODUCT_NAME;
        this.inboundData.PRODUCT_CODE = selected.PRODUCT_CODE;
        this.inboundData.PRODUCT_TYPE = selected.PRODUCT_TYPE;
        this.inboundData.UNIT_PRICE = selected.UNIT_PRICE;
        this.inboundData.CURRENT_STOCK = selected.STOCK_QUANTITY;
        
        // 显示产品类型中文
        this.inboundData.PRODUCT_TYPE_TEXT = this.getProductTypeName(selected.PRODUCT_TYPE);
      }
    },

    // 提交入库
    submitInbound() {
      if (!this.inboundData.PRODUCT_ID) {
        alert("请选择产品");
        return;
      }
      if (!this.inboundData.QUANTITY || this.inboundData.QUANTITY <= 0) {
        alert("请输入有效的入库数量");
        return;
      }
      // 采购价格和采购渠道改为非必填
      if (!this.inboundData.OPERATION_DATE) {
        alert("请选择操作日期");
        return;
      }

      var confirmMsg = this.inboundEditMode ? "是否确认修改入库信息？修改数量将重新计算库存。" : "是否确认入库？";
      if (!confirm(confirmMsg)) {
        return;
      }

      // 添加日志，查看提交的数据
      console.log("提交入库数据：", this.inboundData);
      console.log("图片字段：", {
        IMGPATH: this.inboundData.IMGPATH,
        IMGPATH_YS: this.inboundData.IMGPATH_YS,
        URL: this.inboundData.URL
      });

      var busData = {
        row: this.inboundData
      };
      var methodName = this.inboundEditMode ? "editInbound" : "addInventory";
      var paramData = {
        headerData: {
          op: this.inboundOp,
          methodName: methodName
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.loadInboundList();
          this.mainLoad(); // 刷新产品列表
          this.inboundDialogVisible = false;
          return;
        }
      });
    },

    // 出库管理相关方法
    // 加载出库列表
    loadOutboundList() {
      var busData = {
        pageSet: this.outboundPageSet,
        search: this.outboundSearch
      };
      var paramData = {
        headerData: {
          op: this.outboundOp,
          methodName: "loadOutboundList"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess) {
          this.outboundPageSet.totalNums = data.totalNums;
          this.outboundTableData = data.content;
        }
      });
    },

    // 出库分页
    handleOutboundSizeChange(val) {
      this.outboundPageSet.pageSize = val;
      this.loadOutboundList();
    },
    handleOutboundCurrentChange(val) {
      this.outboundPageSet.currentPage = val;
      this.loadOutboundList();
    },

    // 打开新增出库对话框
    addOutboundHandler() {
      this.outboundData = {
        OPERATION_TYPE: "OUT",
        PRODUCT_ID: "",
        PRODUCT_NAME: "",
        PRODUCT_CODE: "",
        PRODUCT_TYPE: "",
        PRODUCT_TYPE_TEXT: "",
        CURRENT_STOCK: "",
        PURCHASE_PRICE_DISPLAY: "",
        QUANTITY: "",
        CK_PRICE: "",
        OPERATION_DATE: this.getCurrentDateYYYYMMDD(),
        HOUSEID: "",
        HOUSE_NAME: "",
        HOUSE_ADDRESS: "",
        RECIPIENT_NAME: "",
        RECIPIENT_DATE: "",
        REMARKS: "",
        IMGPATH: "",
        IMGPATH_YS: "",
        URL: "",
        imageFileList: []
      };
      // 加载产品列表和房源列表
      this.loadProductListForOutbound();
      this.loadHouseList();
      this.outboundDialogVisible = true;
    },

    // 加载出库可选产品列表
    loadProductListForOutbound() {
      var busData = {
        pageSet: {
          currentPage: 1,
          pageSize: 1000
        },
        search: {
          PRODUCT_NAME: "",
          PRODUCT_TYPE: "",
          PRODUCT_CATEGORY: "",
          PRODUCT_STATUS: "1" // 只加载在售产品
        }
      };
      var paramData = {
        headerData: {
          op: "adminProductsGl",
          methodName: "mainLoad"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess) {
          this.productListForOutbound = data.content;
        }
      });
    },

    // 搜索产品（远程搜索 - 出库）
    searchProductsForOutbound(query) {
      if (query !== '') {
        this.outboundProductSearchLoading = true;
        var busData = {
          pageSet: {
            currentPage: 1,
            pageSize: 1000
          },
          search: {
            PRODUCT_NAME: query,
            PRODUCT_TYPE: "",
            PRODUCT_CATEGORY: "",
            PRODUCT_STATUS: "1"
          }
        };
        var paramData = {
          headerData: {
            op: "adminProductsGl",
            methodName: "mainLoad"
          },
          busData: busData
        };
        this.utilPost.paramData = paramData;
        this.utilPost.sendPost().then(data => {
          this.outboundProductSearchLoading = false;
          if (data.isSuccess) {
            this.productListForOutbound = data.content;
          }
        });
      } else {
        this.loadProductListForOutbound();
      }
    },

    // 出库产品选择改变
    handleOutboundProductChange(val) {
      const selected = this.productListForOutbound.find(item => item.PRODUCT_ID === val);
      if (selected) {
        this.outboundData.PRODUCT_NAME = selected.PRODUCT_NAME;
        this.outboundData.PRODUCT_CODE = selected.PRODUCT_CODE;
        this.outboundData.PRODUCT_TYPE = selected.PRODUCT_TYPE;
        this.outboundData.CURRENT_STOCK = selected.STOCK_QUANTITY;
        
        // 显示产品类型中文
        this.outboundData.PRODUCT_TYPE_TEXT = this.getProductTypeName(selected.PRODUCT_TYPE);
        
        // 查询该产品最近的入库价格
        this.getLatestPurchasePrice(val);
      }
    },

    // 获取产品最近的入库价格
    getLatestPurchasePrice(productId) {
      // 先清空入库价格显示
      this.outboundData.PURCHASE_PRICE_DISPLAY = "";
      
      var busData = {
        PRODUCT_ID: productId
      };
      var paramData = {
        headerData: {
          op: this.inboundOp,
          methodName: "getLatestPurchasePrice"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess && data.content) {
          this.outboundData.PURCHASE_PRICE_DISPLAY = data.content;
        } else {
          this.outboundData.PURCHASE_PRICE_DISPLAY = "暂无";
        }
      }).catch(() => {
        this.outboundData.PURCHASE_PRICE_DISPLAY = "暂无";
      });
    },

    // 加载房源列表
    loadHouseList() {
      var busData = {
        HOUSE_NAME: "" // 空关键字，加载所有符合条件的房源
      };
      var paramData = {
        headerData: {
          op: this.outboundOp,
          methodName: "loadHouseList"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess) {
          this.houseList = data.content;
        }
      });
    },

    // 搜索房源（远程搜索）
    searchHouses(query) {
      if (query !== '') {
        this.houseSearchLoading = true;
        var busData = {
          HOUSE_NAME: query
        };
        var paramData = {
          headerData: {
            op: this.outboundOp,
            methodName: "loadHouseList"
          },
          busData: busData
        };
        this.utilPost.paramData = paramData;
        this.utilPost.sendPost().then(data => {
          this.houseSearchLoading = false;
          if (data.isSuccess) {
            this.houseList = data.content;
          }
        });
      } else {
        this.loadHouseList();
      }
    },

    // 房源选择改变
    handleHouseChange(val) {
      const selected = this.houseList.find(item => item.HOUSEID === val);
      if (selected) {
        this.outboundData.HOUSE_NAME = selected.HOUSE_NAME;
        this.outboundData.HOUSE_ADDRESS = selected.ADDRESS;
      }
    },

    // 提交出库
    submitOutbound() {
      if (!this.outboundData.PRODUCT_ID) {
        alert("请选择产品");
        return;
      }
      if (!this.outboundData.QUANTITY || this.outboundData.QUANTITY <= 0) {
        alert("请输入有效的出库数量");
        return;
      }
      if (parseInt(this.outboundData.QUANTITY) > parseInt(this.outboundData.CURRENT_STOCK)) {
        alert("出库数量不能大于当前库存");
        return;
      }
      if (!this.outboundData.OPERATION_DATE) {
        alert("请选择操作日期");
        return;
      }
      if (!this.outboundData.HOUSEID) {
        alert("请选择房源");
        return;
      }

      if (!confirm("是否确认出库？")) {
        return;
      }

      var busData = {
        row: this.outboundData
      };
      var paramData = {
        headerData: {
          op: this.outboundOp,
          methodName: "addInventory"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.loadOutboundList();
          this.mainLoad(); // 刷新产品列表
          this.outboundDialogVisible = false;
          return;
        }
      });
    },

    // 打开售卖对话框
    openSellDialog(row) {
      this.sellData = {
        OUTBOUND_ID: row.OUTBOUND_ID,
        PRODUCT_ID: row.PRODUCT_ID,
        PRODUCT_NAME: row.PRODUCT_NAME,
        QUANTITY: row.QUANTITY,
        PURCHASE_PRICE_DISPLAY: row.PURCHASE_PRICE || "", // 入库价格（只读显示）
        CK_PRICE: row.CK_PRICE || "", // 如果已有出库价格，显示出来
        IMGPATH: "",
        IMGPATH_YS: "",
        URL: "",
        imageFileList: []
      };
      this.sellDialogVisible = true;
    },

    // 提交售卖
    submitSell() {
      // 验证出库价格
      if (!this.sellData.CK_PRICE || this.sellData.CK_PRICE <= 0) {
        alert("请输入有效的出库价格！");
        return;
      }

      if (!confirm("确认要将该出库单标记为售卖吗？\n售卖后将不可回收！")) {
        return;
      }

      console.log("售卖提交数据 - sellData:", this.sellData);

      var busData = {
        OUTBOUND_ID: this.sellData.OUTBOUND_ID,
        PRODUCT_ID: this.sellData.PRODUCT_ID,
        QUANTITY: this.sellData.QUANTITY,
        CK_PRICE: this.sellData.CK_PRICE,
        IMGPATH: this.sellData.IMGPATH,
        IMGPATH_YS: this.sellData.IMGPATH_YS,
        URL: this.sellData.URL,
        OUTBOUND_STATUS: 'SOLD'
      };
      
      console.log("售卖提交数据 - busData:", busData);
      
      var paramData = {
        headerData: {
          op: this.outboundOp,
          methodName: "sellOutbound"
        },
        busData: busData
      };
      
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.sellDialogVisible = false;
          this.loadOutboundList();
          this.mainLoad(); // 刷新产品列表
        }
      });
    },

    // 售卖图片上传成功
    handleSellImageSuccess(response, file, fileList) {
      console.log("售卖图片上传返回数据：", response);
      if (response.isSuccess) {
        // 确保这些字段有值（与入库管理的字段名保持一致）
        this.sellData.IMGPATH = response.content.filePath || "";
        this.sellData.IMGPATH_YS = response.content.filePath_ys || response.content.filePath || "";
        this.sellData.URL = response.content.url || "";
        
        console.log("售卖保存的图片字段：", {
          IMGPATH: this.sellData.IMGPATH,
          IMGPATH_YS: this.sellData.IMGPATH_YS,
          URL: this.sellData.URL
        });
        
        this.$message.success("图片上传成功！");
      } else {
        this.$message.error(response.msg || "图片上传失败！");
        // 移除上传失败的文件
        const index = fileList.indexOf(file);
        if (index > -1) {
          fileList.splice(index, 1);
        }
      }
    },

    // 售卖图片上传前验证
    beforeSellImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt500KB = file.size / 1024 < 500;
      
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt500KB) {
        this.$message.error("上传的图片大小不能超过 500KB!");
        return false;
      }
      
      return isJPG && isLt500KB;
    },

    // 售卖图片移除
    handleSellImageRemove(file, fileList) {
      this.sellData.IMGPATH = "";
      this.sellData.IMGPATH_YS = "";
      this.sellData.URL = "";
    },

    // 修改出库单状态
    changeOutboundStatus(row, status) {
      let statusText = status === 'RECOVER' ? '回收' : '售卖';
      let confirmMsg = `是否确认将该出库单标记为${statusText}？`;
      
      if (status === 'SOLD') {
        confirmMsg += '\n注意：售卖后将不可回收！';
      }
      
      if (!confirm(confirmMsg)) {
        return;
      }

      var busData = {
        INVENTORY_ID: row.OUTBOUND_ID || row.INVENTORY_ID,
        OUTBOUND_STATUS: status,
        PRODUCT_ID: row.PRODUCT_ID,
        QUANTITY: row.QUANTITY
      };
      var paramData = {
        headerData: {
          op: this.outboundOp,
          methodName: "changeOutboundStatus"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.loadOutboundList();
          this.mainLoad(); // 刷新产品列表
          return;
        }
      });
    },

    // 作废出库记录
    cancelOutbound(row) {
      if (!confirm("是否确认作废该出库记录？\n作废后将恢复库存，该操作不可撤销！")) {
        return;
      }

      var busData = {
        OUTBOUND_ID: row.OUTBOUND_ID,
        PRODUCT_ID: row.PRODUCT_ID,
        QUANTITY: row.QUANTITY
      };
      var paramData = {
        headerData: {
          op: this.outboundOp,
          methodName: "cancelOutbound"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.loadOutboundList();
          this.mainLoad(); // 刷新产品列表
          return;
        }
      });
    },

    // 获取当前日期 yyyy-MM-dd格式
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 获取当前日期 yyyyMMdd格式
    getCurrentDateYYYYMMDD() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    },

    // 入库图片上传成功回调
    handleInboundImageSuccess(response, file, fileList) {
      console.log("图片上传返回数据：", response);
      if (response.isSuccess) {
        // 确保这些字段有值
        this.inboundData.IMGPATH = response.content.filePath || "";
        this.inboundData.IMGPATH_YS = response.content.filePath_ys || response.content.filePath || "";
        this.inboundData.URL = response.content.url || "";
        
        console.log("保存的图片字段：", {
          IMGPATH: this.inboundData.IMGPATH,
          IMGPATH_YS: this.inboundData.IMGPATH_YS,
          URL: this.inboundData.URL
        });
        
        this.$message.success("图片上传成功");
      } else {
        this.$message.error("上传失败：" + response.msg);
      }
    },

    // 入库图片上传前校验
    beforeInboundImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt500KB = file.size / 1024 < 500;
      
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt500KB) {
        this.$message.error("上传的图片大小不能超过 500KB!");
        return false;
      }
      
      return isJPG && isLt500KB;
    },

    // 入库图片移除
    handleInboundImageRemove(file, fileList) {
      this.inboundData.IMGPATH = "";
      this.inboundData.IMGPATH_YS = "";
      this.inboundData.URL = "";
      this.inboundData.imageFileList = [];
    },

    // 出库图片上传成功回调
    handleOutboundImageSuccess(response, file, fileList) {
      console.log("出库图片上传返回数据：", response);
      if (response.isSuccess) {
        this.outboundData.IMGPATH = response.content.filePath || "";
        this.outboundData.IMGPATH_YS = response.content.filePath_ys || response.content.filePath || "";
        this.outboundData.URL = response.content.url || "";
        
        console.log("出库保存的图片字段：", {
          IMGPATH: this.outboundData.IMGPATH,
          IMGPATH_YS: this.outboundData.IMGPATH_YS,
          URL: this.outboundData.URL
        });
        
        this.$message.success("图片上传成功");
      } else {
        this.$message.error("上传失败：" + response.msg);
      }
    },

    // 出库图片上传前校验
    beforeOutboundImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt500KB = file.size / 1024 < 500;
      
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt500KB) {
        this.$message.error("上传的图片大小不能超过 500KB!");
        return false;
      }
      
      return isJPG && isLt500KB;
    },

    // 出库图片移除
    handleOutboundImageRemove(file, fileList) {
      this.outboundData.IMGPATH = "";
      this.outboundData.IMGPATH_YS = "";
      this.outboundData.URL = "";
      this.outboundData.imageFileList = [];
    },

    // 产品类型维护相关方法
    // 加载产品类型列表（用于下拉框）
    loadProductTypeList() {
      var paramData = {
        headerData: {
          op: this.productTypeOp,
          methodName: "getAllProductTypes"
        },
        busData: {}
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess) {
          this.productTypeList = data.content || [];
        }
      });
    },

    // 加载产品类型表格列表（用于Tab页面显示）
    loadProductTypeTableList() {
      var busData = {
        pageSet: this.productTypePageSet,
        search: this.productTypeSearch
      };
      var paramData = {
        headerData: {
          op: this.productTypeOp,
          methodName: "mainLoad"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess) {
          this.productTypePageSet.totalNums = data.totalNums;
          this.productTypeTableData = data.content || [];
        }
      });
    },

    // 产品类型分页
    handleProductTypeSizeChange(val) {
      this.productTypePageSet.pageSize = val;
      this.loadProductTypeTableList();
    },
    handleProductTypeCurrentChange(val) {
      this.productTypePageSet.currentPage = val;
      this.loadProductTypeTableList();
    },

    // 打开新增产品类型对话框
    addProductTypeHandler() {
      this.productTypeData = {
        TYPE_CODE: "",
        TYPE_NAME: "",
        TYPE_DESC: "",
        STATUS: "1"
      };
      this.productTypeFlag = "ADD";
      this.productTypeDialogVisible = true;
    },

    // 打开编辑产品类型对话框
    editProductTypeHandler(row) {
      this.productTypeData = JSON.parse(JSON.stringify(row));
      this.productTypeFlag = "UPT";
      this.productTypeDialogVisible = true;
    },

    // 提交产品类型（新增或编辑）
    submitProductType() {
      // 只验证类型名称（编码由后端自动生成）
      if (!this.productTypeData.TYPE_NAME) {
        alert("请输入类型名称");
        return;
      }

      if (!confirm("是否确认提交？")) {
        return;
      }

      var busData = {
        row: this.productTypeData,
        flag: this.productTypeFlag
      };
      var paramData = {
        headerData: {
          op: this.productTypeOp,
          methodName: "addOrEditorOrDel"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.loadProductTypeTableList();
          this.loadProductTypeList(); // 刷新下拉框列表
          this.productTypeDialogVisible = false;
          return;
        }
      });
    },

    // 删除产品类型
    deleteProductTypeHandler(row) {
      if (!confirm("删除该产品类型后，使用该类型的产品将无法正常显示。是否确认删除？")) {
        return;
      }

      var busData = {
        row: row,
        flag: "DEL"
      };
      var paramData = {
        headerData: {
          op: this.productTypeOp,
          methodName: "addOrEditorOrDel"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.loadProductTypeTableList();
          this.loadProductTypeList(); // 刷新下拉框列表
          return;
        }
      });
    },

    // 根据类型编码获取类型名称
    getProductTypeName(typeCode) {
      const type = this.productTypeList.find(item => item.TYPE_CODE === typeCode);
      return type ? type.TYPE_NAME : typeCode;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.trialScGlIndexClass {
  .addClassModel {
    padding-left: 15px;
    padding-right: 15px;
  }
  .trainSetClassMain .el-input {
    width: 60% !important;
  }
  .el-dialog {
    margin-top: 15px !important;
    width: 90%;
  }
  .searchMainClass .el-input {
    width: 150px !important;
  }
  .longLabelClass .el-input {
    width: 372px !important;
  }
  .el-table td.el-table__cell div {
    font-weight: 600 !important;
  }
  .cell {
    text-align: center !important;
  }
  .mainDivJd {
    .el-progress-bar__innerText {
      color: #f300ff !important;
    }
  }

  .fzrsMainDiv {
    text-align: left;
    margin-bottom: 10px;
  }
  .dwInfoDivId {
    .el-form-item__content {
      float: left;
    }
  }
  /deep/ .el-dialog {
    margin-top: 15px !important;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
  /deep/ .el-form-item__label {
    line-height: 32px !important;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/accessoriesGlIndex/AccessoriesGlIndex.vue